import { PaymentMethodCardTemplate, PaymentMethodCardTemplateProps } from "./template";

export type PaymentMethodCardProps = PaymentMethodCardTemplateProps;

export const PaymentMethodCard = (props: PaymentMethodCardProps): JSX.Element => {
  return <PaymentMethodCardTemplate {...props} />;
};
